// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__amvKH","description":"PatientConsentPreview_description__1TmET"};